import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const icsParams = 'industrial|commercial|office|shops';

  const router = new Router({
    mode: 'history',
    base: '/ics/property',
    routes: [
      {
        name: 'home',
        path: '',
        component: () => import('./home'),
      },
      {
        name: 'homeAlt',
        path: '/home',
        component: () => import('./home'),
      },
      {
        name: 'homeTest',
        path: '/home_test',
        component: () => import('./home'),
      },
      {
        name: 'icsHome',
        path: `/:p1(${icsParams})?`,
        component: () => import('./home'),
      },
      {
        name: 'icsHomeAlt',
        path: `/home/:p1(${icsParams})?`,
        component: () => import('./home'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    Vue.$gmapDefaultResizeBus.$emit('resize');
    next();
  });

  return router;
};
